import { ItemFile } from "../../../../store/viewmodels/ItemFileViewModel";
import { Item } from "../../../../store/viewmodels/ItemViewModel";
import { getFileElement } from "../../../../utils/TaskContentServices";

export interface MemoryGameModalProps {
    close: () => void,
    item: Item
}

function MemoryGameModal(props: MemoryGameModalProps): JSX.Element {

    let itemFiles: ItemFile[] = props.item.files;
    let file: ItemFile | undefined = itemFiles.find(file => file.file.includes("mp4") || file.file.includes("webm"));

    let instructionElement: JSX.Element = <></>;

    if (file !== undefined) {
        instructionElement = getFileElement(file);
    }

    let instructionText = props.item.content !== "null" ? props.item.content : "";

    return (
        <div className="m-6">
            <h2 className="mt-6 mb-4 text-center text-2xl font-extrabold text-gray-900">{props.item.name}</h2>
            <div className="">
                <p className="mb-4">
                    {instructionText}
                </p>
                <div className="m-auto">
                    {instructionElement}
                </div>
            </div>
            <div className="w-full">
                <div className="my-4 w-1/4 float-right">
                    <button
                        onClick={props.close}
                        type="button"
                        className="block w-full text-sm font-medium rounded-md border-transparent bg-gray-500 hover:bg-gray-400 focus:shadow-outline text-white font-bold py-2 px-4 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500">
                        Sulje
                    </button>
                </div>
            </div>
        </div>
    );
}

export default MemoryGameModal;
